import script from "./QuillImplementaion.vue?vue&type=script&setup=true&lang=js"
export * from "./QuillImplementaion.vue?vue&type=script&setup=true&lang=js"

import "./QuillImplementaion.vue?vue&type=style&index=0&id=2f001c31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f001c31"]])

export default __exports__